import { render } from "./BottomContent.vue?vue&type=template&id=2030b4e8"
import script from "./BottomContent.vue?vue&type=script&lang=ts"
export * from "./BottomContent.vue?vue&type=script&lang=ts"
script.render = render

export default script